export default __webpack_public_path__ + "static/media/icon-advanced-technology.411fcb8d.svg";